module.exports = __webpack_public_path__ + "img/jilu.1905a0d7.png";